import { PhasrSidePanelComponent } from './component/PhasrSidePanelComponent';
import { WEB_COMPONENT_PHASR_SIDE_PANEL } from '../webcomponents.constants';

export { PhasrSidePanelComponent };

window.customElements.define(WEB_COMPONENT_PHASR_SIDE_PANEL, PhasrSidePanelComponent);
